import { CheckoutSteps } from '../util/enums';

export const WeightUnitEnum = Object.freeze([
  Object.freeze({ value: 'g', label: 'G' }),
  Object.freeze({ value: 'kg', label: 'Kg' }),
  Object.freeze({ value: 'lb', label: 'Lb' }),
  Object.freeze({ value: 'oz', label: 'Oz' }),
]);

export const checkoutStepsTabs = [
  { step: CheckoutSteps.SHIPPING, label: 'Your Information' },
  { step: CheckoutSteps.CARRIERS, label: 'Shipping Method' },
  { step: CheckoutSteps.PAYMENT, label: 'Payment' },
];
